/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deleteaccountemailinstructions3Inputs */

const en_deleteaccountemailinstructions3 = /** @type {(inputs: Deleteaccountemailinstructions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click below to send an email with instructions on how to delete your account. This action cannot be undone.`)
};

const de_deleteaccountemailinstructions3 = /** @type {(inputs: Deleteaccountemailinstructions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicke unten, um eine E-Mail mit Anweisungen zur Kontolöschung zu erhalten. Diese Aktion kann nicht rückgängig gemacht werden.`)
};

/**
* | output |
* | --- |
* | "Click below to send an email with instructions on how to delete your account. This action cannot be undone." |
*
* @param {Deleteaccountemailinstructions3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deleteaccountemailinstructions3 = /** @type {((inputs?: Deleteaccountemailinstructions3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleteaccountemailinstructions3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleteaccountemailinstructions3(inputs)
	return de_deleteaccountemailinstructions3(inputs)
});
export { deleteaccountemailinstructions3 as "deleteAccountEmailInstructions" }